import axios from '@/utils/axios'
const rootUrl = 'flow/website/setting/'
const api = {
  GetTemplateList: rootUrl + 'getTemplateList',
  SetTemplateAlias: rootUrl + 'setTemplateAlias',
  SetTemplateRequied: rootUrl + 'setTemplateRequied',
  SetTemplateShow: rootUrl + 'setTemplateShow',
  GetCleanTimeList: rootUrl + 'getCleanTimeList',
  GetCountTimeList: rootUrl + 'getCountTimeList',
  SetCleanTime: rootUrl + 'setCleanTime',
  SetCountTime: rootUrl + 'setCountTime',
  GetLogPage: rootUrl + 'getLogPage',
  SetTemplateSelf: rootUrl + 'setTemplateSelf',
  SetHistoryConfig: rootUrl + 'setHistoryConfig',
  GetHistoryConfig: rootUrl + 'getHistoryConfig',
  SalesDataSave: 'flow/website/import/save',
  GetTemplateField: rootUrl + 'getTemplateField',
  GetLastLog: rootUrl + 'getLastLog',
  GetCustomClientFlowSetting: rootUrl + 'getCustomClientFlowSetting',
  SetCustomClientFlowSetting: rootUrl + 'setCustomClientFlowSetting',
}


/**
 * 导入模版配置列表
 */
export function getTemplateList(data_type) {
  return axios.formRequest.post(api.GetTemplateList, { data_type })
}

/**
 * 设置模版别名接口
 */
export function setTemplateAlias(tcid, alias, data_type) {
  return axios.formRequest.post(api.SetTemplateAlias, {
    tcid,
    alias,
    data_type,
  })
}

/**
 * 设置是否必填接口 0 否 1 是
 */
export function setTemplateRequied(tcid, is_required, data_type) {
  return axios.formRequest.post(api.SetTemplateRequied, {
    tcid,
    is_required,
    data_type,
  })
}

/**
 * 设置是否显示接口 0 否 1 是
 */
export function setTemplateShow(tcid, is_show, data_type,is_tag) {
  return axios.formRequest.post(api.SetTemplateShow, {
    tcid,
    is_show,
    data_type,
    is_tag
  })
}
/**
 * 获取清洗时间列表接口
 */
export function getCleanTimeList(year) {
  return axios.formRequest.post(api.GetCleanTimeList, { year })
}

/**
 * 获取账期列表接口
 */
export function getCountTimeList(year) {
  return axios.formRequest.post(api.GetCountTimeList, { year })
}

/**
 * 设置清洗时间接口
 */
export function setCleanTime(time, operator_content) {
  return axios.formRequest.post(api.SetCleanTime, { time, operator_content })
}

/**
 * 设置统计帐期
 */
export function setCountTime(time, operator_content) {
  return axios.formRequest.post(api.SetCountTime, { time, operator_content })
}

/**
 * 获取日志记录
 */
export function getLogPage(parameter) {
  return axios.formRequest.post(api.GetLogPage, parameter)
}

/**
 * 编辑自定义字段
 */
export function setTemplateSelf(tcid, name, data_type) {
  return axios.formRequest.post(api.SetTemplateSelf, { tcid, name, data_type })
}

/**
 * 获取历史月份流向配置
 */
export function getHistoryConfig() {
  return axios.formRequest.post(api.GetHistoryConfig, {})
}

/**
 * 设置历史流向配置接口
 */
export function setHistoryConfig(parameter) {
  return axios.formRequest.post(api.SetHistoryConfig, parameter)
}

/**
 * 销售数据表格导入接口(保存)
 */
export function salesDataSave(type, file_list, data_type, parameter = {}) {
  return axios.formRequest.post(api.SalesDataSave, {
    type,
    file_list,
    data_type,
    ...parameter,
  })
}

/**
 * 获取自定义字段列表
 */
export function getTemplateField(data_type = 1) {
  return axios.formRequest.post(api.GetTemplateField, { data_type })
}

/**
 * 最新日志列表接口
 */
export function getLastLog() {
  return axios.formRequest.post(api.GetLastLog, {})
}

/**
 * 获取自定义档案类型流向配置
 */
export function getCustomClientFlowSetting() {
  return axios.formRequest.post(api.GetCustomClientFlowSetting, {})
}

/**
 * 获取自定义档案类型流向配置
 */
export function setCustomClientFlowSetting(parameter) {
  return axios.formRequest.post(api.SetCustomClientFlowSetting, parameter)
}

/**
 * 获取自定义档案类型流向配置
 */
export function setFlowDayOriginalSetting(parameter) {
  return axios.formRequest.post(
    'flow/website/setting/setFlowDayOriginalSetting',
    parameter,
  )
}


/**
 * 新增流向数据查询不可见字段配置
 */
 export function addJobFlowTitleConfig(parameter) {
  return axios.formRequest.post(
    'flow/website/setting/addJobFlowTitleConfig',
    parameter,
  )
}


/**
 * 新增流向数据查询不可见字段配置  获取已经配置的职位id
 */
 export function getAlreadyJobConfig(parameter) {
  return axios.formRequest.post(
    'flow/website/setting/getAlreadyJobConfig',
    parameter,
  )
}
